export default "__VITE_ASSET__e0e28913__"